import React from 'react';
import { Field, withFormik, FormikProps } from 'formik';
import * as yup from 'yup';
import { InputField } from '@/components/formFields/InputField';
import { passwordValidation, passwordConfirmValidation } from '../../utils/passwordValidation';
import { Button } from '@/components/ui/Button';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight, ArrowLeft } from 'lucide-react';

interface ResetPasswordConfirmFormValues {
  password: string;
  confirm: string;
}

interface ResetPasswordConfirmFormOuterProps {
  submit: (
    values: ResetPasswordConfirmFormValues,
    setErrors: (errors: Record<string, string>) => void
  ) => Promise<void>;
  errorFromServer?: string;
}

type ResetPasswordConfirmFormInnerProps = FormikProps<ResetPasswordConfirmFormValues> &
  ResetPasswordConfirmFormOuterProps;

class C extends React.Component<ResetPasswordConfirmFormInnerProps> {
  render() {
    const { values, handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="space-y-1.5">
          <label className="text-[11px] font-medium uppercase tracking-wider text-neutral-600 inline-block">
            Nové heslo
            <span className="text-danger ml-1">*</span>
          </label>
          <div className="relative">
            <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
            <Field
              type="password"
              name="password"
              placeholder="Nové heslo"
              value={values.password}
              component={InputField}
              data-testid="reset-password-new-input"
              className="pl-9"
            />
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="text-[11px] font-medium uppercase tracking-wider text-neutral-600 inline-block">
            Potvrzení hesla
            <span className="text-danger ml-1">*</span>
          </label>
          <div className="relative">
            <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
            <Field
              type="password"
              name="confirm"
              placeholder="Znovu heslo pro kontrolu"
              value={values.confirm}
              component={InputField}
              data-testid="reset-password-confirm-input"
              className="pl-9"
            />
          </div>
        </div>

        <Button
          type="submit"
          size="lg"
          className="w-full"
          data-testid="reset-password-confirm-submit-btn"
        >
          Potvrdit
          <ArrowRight size={14} />
        </Button>

        <div className="flex justify-center">
          <Link
            to="/login"
            className="text-sm text-neutral-500 hover:text-neutral-700 inline-flex items-center gap-1.5 transition-colors"
          >
            <ArrowLeft size={14} />
            Zpět na přihlášení
          </Link>
        </div>
      </form>
    );
  }
}

const validationSchema = yup.object({
  password: passwordValidation,
  confirm: passwordConfirmValidation(yup.ref('password')),
});

const ResetPasswordConfirmForm = withFormik<
  ResetPasswordConfirmFormOuterProps,
  ResetPasswordConfirmFormValues
>({
  validationSchema,

  mapPropsToValues: () => ({ password: '', confirm: '' }),
  handleSubmit: async (values, { props, setErrors }) => {
    await props.submit(values, setErrors);
  },
})(C);

export default ResetPasswordConfirmForm;
